export default __webpack_public_path__ + "static/IN-9008-vs-IN-5905_Night_resTestBig-9dc195fdf980af0a99db0834df536b32.webp";